import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPotentialActivityEntities as GetPotentialActivityEntitiesQuery,
    GetPotentialActivityEntitiesVariables as GetPotentialActivityEntitiesVariables,
    GetPotentialActivityEntities_activityPotentialEntities_relatedEntities as RelatedEntities,
    GetPotentialActivityEntities_activityPotentialEntities_participants as Participants,
} from 'nutshell-graphql-types';

import GET_POTENTIAL_ACTIVITY_ENTITIES from '../queries/get-potential-activity-entities.graphql';

export const useGetPotentialActivityEntities = (
    entityIds: string[],
    shouldSkip: boolean
): {
    relatedEntities?: RelatedEntities[];
    participants?: Participants[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetPotentialActivityEntitiesQuery,
        GetPotentialActivityEntitiesVariables
    >(GET_POTENTIAL_ACTIVITY_ENTITIES, {
        variables: {
            input: {
                entityIds,
            },
        },
        skip: shouldSkip,
    });

    const activityPotentialEntities = data ? data.activityPotentialEntities : null;

    const {relatedEntities, participants} = activityPotentialEntities || {};

    return {
        relatedEntities,
        participants,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
